class WelcomeMessage extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.textContent = this.showWelcomeMessage()
  }

  showWelcomeMessage () {
    const tDate = new Date()

    const currentTime = tDate.toLocaleTimeString({
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })

    if (currentTime > '06:00:00' && currentTime < '12:00:00') {
      return `${window.theme.strings.goodMorning},`
    } else if (currentTime > '12:00:00' && currentTime < '18:00:00') {
      return `${window.theme.strings.goodAfternoon},`
    } else if (currentTime > '18:00:00') {
      return `${window.theme.strings.goodEvening},`
    } else {
      return `${window.theme.strings.welcome},`
    }
  }
}

if (!customElements.get('welcome-message')) {
  customElements.define('welcome-message', WelcomeMessage)
}
